<template>
  <div class="newbox">
    <div class="headerimg">
      <img :src="bannerImg" alt="" v-if="bannerImg">
      <!-- <img src="../../assets/img/servive-active-headrimg.png" alt="" v-else> -->
    </div>
    <div class="headertitle">
      <h2>媒体报道</h2>
    </div>
    <div class="act_con" v-for="(item,index) in listArr" :key="item.eid">
      <div class="act_top">
        <div></div>
        <div>
          <img :src="item.img_small" alt="">
          <div>{{item.dat}}</div>
        </div>
      </div>
      <div class="act_bot">
        <p>{{item.title}}</p>
        <!-- <p>{{item.s_content}}</p> -->
        <div v-html="item.more" v-show="item.moreShow" class="act_more"></div>
        <div class="act_line"></div>
        <div class="circle"><div></div></div>
      </div>
      <div @click="moreCon(item.eid,index,item)" class="lookmore" v-show="!item.moreShow">查看更多</div>
      <!-- <div @click="sendOther()" class="zhuanfa">转发</div> -->
      <div @click="moreCon(item.eid,index,item)" class="lookmore" v-show="item.moreShow">收起</div>
    </div>
    <div class="next" @click="nextPage()" v-if="showNext">点击查看下一页内容</div>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
import { media, newActDetil, banner } from '@/api'
import vBottom from '@/components/Bottom.vue'
import { wxshare } from '@/api/share'
// import { async } from 'q'
export default {
  name: 'media',
  components: {
    vBottom
  },
  data () {
    return {
      bannerImg: '', // banner图
      listArr: [], // 显示的内容
      pageNum: 1,
      pageSize: 2,
      jieliu: true,
      showNext: true,
      shareid: this.$route.query.shareid, // 分享的文章详情ID
      shareTitle: this.$route.query.shareTitle, // 分享的文章标题
      sharePage: this.$route.query.page // 分享出去的页码
    }
  },
  methods: {
    tobanner () {
      banner(18).then(res => {
        if (res.status === 1) {
          this.bannerImg = res.msg
        }
      })
    },
    tolist (num) {
      let params = {
        page: num || this.pageNum,
        per_page: this.pageSize
      }
      media(params).then(res => {
        this.jieliu = true
        if (res.status === 1) {
          this.pageNum += 1
          res.msg.data.map(el => el.page = params.page)
          let arr = res.msg.data
          this.listArr = this.listArr.concat(arr)
          if (res.msg.data.length < this.pageSize) {
            this.showNext = false
          }
        }
      })
    },
    // 查看活动的更多内容
    moreCon (id, index, el) {
      // document.getElementsByClassName('mescroll')[0].scrollTop
      if (!this.listArr[index].moreShow) { // 展开
        this.shareid = id
        this.shareTitle = el.title
        this.sharePage = el.page

        // console.log(this.shareid,this.shareTitle,this.sharePage)

        newActDetil({ id }).then(res => {
          if (res.status === 1) {
            this.listArr.map((item, index) => {
              if (item.eid === id) {
                this.$set(this.listArr[index], 'more', res.msg.m_content)
                this.$set(this.listArr[index], 'moreShow', true)
              }
            })
          }
        })
      } else { // 收起
        let oneval = !this.listArr[index].moreShow
        this.$set(this.listArr[index], 'moreShow', oneval)

        this.shareid = ''
      }

      this.updateShare() // 更新分享
    },
    // 下一页
    nextPage () {
      if (this.jieliu) {
        this.jieliu = false
        this.tolist(this.pageNum)
      }
    },
    updateShare () { // 更新分享
      if (this.shareid) {
        let shareConfig = {}
        if (this.shareTitle) {
          shareConfig = {
            title: this.shareTitle,
            desc: '华帝家居',
            url: `http://hj.vattihome.com/mob/media?shareid=${this.shareid}&page=${this.sharePage}`,
            imgurl: 'http://hj.vattihome.com/mob/hdfenxiang.png',
            qx: 0
          }
        } else {
          shareConfig = {
            title: '华帝家居-媒体报道',
            desc: '华帝家居',
            url: `http://hj.vattihome.com/mob/media?shareid=${this.shareid}&page=${this.sharePage}`,
            imgurl: 'http://hj.vattihome.com/mob/hdfenxiang.png',
            qx: 0
          }
        }
        wxshare(shareConfig)
      } else {
        let shareConfig = {
          title: '华帝家居-媒体报道',
          desc: '华帝家居',
          url: `http://hj.vattihome.com/mob/media`,
          imgurl: 'http://hj.vattihome.com/mob/hdfenxiang.png',
          qx: 0
        }
        wxshare(shareConfig)
      }
    },
    // 设置微信分享
    setWxShare () {
      let shareConfig = {
        title: '华帝家居-首页',
        desc: '华帝家居',
        url: 'http://hj.vattihome.com/mob/',
        imgurl: 'http://hj.vattihome.com/mob/hdfenxiang.png',
        qx: 0
      }
      wxshare(shareConfig)
    }
  },
  created () {
    if (this.shareid) {
      this.tolist(this.sharePage)
      setTimeout(() => {
        newActDetil({ id: this.shareid }).then(res => {
          if (res.status === 1) {
            let item = this.listArr.find(el => parseInt(el.eid) === parseInt(this.shareid))
            this.$set(item, 'more', res.msg.m_content)
            this.$set(item, 'moreShow', true)
          }
        })
      }, 1500)
    } else {
      if (this.GETURL('pagenum')) {
        this.pageNum = this.GETURL('pagenum')
      }
      if (this.GETURL('pagesize')) {
        this.pageSize = this.GETURL('pagesize')
      }
      this.tobanner()
      this.tolist()
    }

    this.updateShare()
  },
  beforeDestroy () {
    this.setWxShare()
  }
}
</script>

<style lang="scss" scoped>
.newbox {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .act_con {
    padding: 0.4rem;
    .act_top {
      position: relative;
      width: 100%;
      height: 3rem;
      >div:nth-of-type(1) {
        width: 1.6rem;
        height: 1rem;
        background-color: #005B48;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      >div:nth-of-type(2) {
        width: 6.3rem;
        height: 2.1rem;
        background-color: #fff;
        position: absolute;
        top: 0.4rem;
        left: 0.4rem;
        z-index: 2;
        >div:nth-of-type(1) {
          width: 1.8rem;
          height: 0.6rem;
          background-color: #005B48;
          position: absolute;
          bottom: -0.4rem;
          left: -0.4rem;
          z-index: 3;
          font-size: 0.26rem;
          color: #fff;
          text-align: center;
          line-height: 0.6rem;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .act_bot {
      font-size: 0.26rem;
      margin-left: 0.4rem;
      width: 100%;
      box-sizing: border-box;
      padding-right: 0.4rem;
      padding-left: 0.3rem;
      position: relative;
      p {
        margin-top: 0.2rem;
        line-height: 0.4rem;
      }
      p:nth-of-type(1) {
        color: #808080;
        font-size: 0.3rem;
      }
      .act_more {
        width: 100%;
        margin-top: 0.2rem;
      }
      .act_line {
        position: absolute;
        left: 0;
        top: 16px;
        bottom: 0;
        width: 1px;
        background-color: #005B48;
      }
      .circle {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #005B48;
        position: absolute;
        top: 0;
        left: -8px;
        >div {
          width: 10px;
          height: 10px;
          background-color: #005B48;
          border-radius: 50%;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    .lookmore {
      width: 1.6rem;
      height: 0.6rem;
      margin-top: 0.2rem;
      border: 1px solid #005B48;
      color: #005B48;
      line-height: 0.6rem;
      text-align: center;
      border-radius: 0.06rem;
      font-size: 0.26rem;
      margin-left: 0.4rem;
    }
    .zhuanfa {
      width: 1.6rem;
      height: 0.6rem;
      margin-top: 0.2rem;
      border: 1px solid #005B48;
      color: #005B48;
      line-height: 0.6rem;
      text-align: center;
      border-radius: 0.06rem;
      font-size: 0.26rem;
      margin-left: 0.4rem;
    }
  }
}
</style>
